export enum RequestStatus {
  OK,
  CANT_REACH_SERVER,
  EMPTY_RESPONSE,
  BAD_REQUEST,
  INTERNAL_SERVER_ERROR,
  CANCELLED,
  OPERATION_NOT_COMPLETE,
}
